import config from "@Config/index";

const normalizeBase = (url: string): string => url.replace(/\/$/, "");

export const getConfiguredCmsBase = (): string =>
  normalizeBase(config.CMS_API_URL || "https://cms.staging-amber.com");

/**
 * Deploy sets CMS_API_URL to a VPC-internal host (cms.internal.*) that web pods
 * often cannot reach (ENOTFOUND / proxy 504). Public cms.* serves the same read API.
 */
export const resolveCmsBaseForRequests = (cmsBase: string): string => {
  if (cmsBase.includes("cms.internal.")) {
    return cmsBase.replace("cms.internal.", "cms.");
  }
  return cmsBase;
};

/**
 * Absolute URL for a Payload CMS API path (must start with `/api/…`).
 */
const getCmsRequestUrl = (apiPath: string): string => {
  const path = apiPath.startsWith("/") ? apiPath : `/${apiPath}`;
  const cmsBase = resolveCmsBaseForRequests(getConfiguredCmsBase());
  return `${cmsBase}${path}`;
};

export default getCmsRequestUrl;
